module.exports = __webpack_public_path__ + "static/03-25da1a9d4d0285df89d1e66956b93cd8.jpg";